<template>
    <v-dialog fullscreen v-model="dialog" transition="dialog-bottom-transition">
        <filter-coach-form @hide="onHide"/>
    </v-dialog>
</template>

<script>

import {mapState, mapMutations} from 'vuex'
import FilterCoachForm from "@/components/student/FilterCoachForm";

export default {
    components: {FilterCoachForm},
    data() {
        return {
            dialog: false,
        }
    },
    computed: {
        ...mapState(['dialogActive']),
    },
    methods: {
        ...mapMutations(['setDialogActive']),
        show() {
            const vm = this
            vm.dialog = true
            vm.setDialogActive(true)
        },
        onHide() {
            const vm = this
            vm.dialog = false
            vm.setDialogActive(false)
        },
    },
    watch: {
        dialogActive(val) {
            if (!val) this.onHide()
        }
    }
}

</script>